const borderRadius = ($value = '1px') => `
    -webkit-border-radius: ${value};
    -moz-border-radius: ${value};
    border-radius: ${value};
`;

const borderShadow = (top, left, blur, color, inset = '') => `
    -webkit-box-shadow:${top} ${left} ${blur} ${color} #{${inset}};
    -moz-box-shadow:${top} ${left} ${blur} ${color} #{${inset}};
    box-shadow:${top} ${left} ${blur} ${color} #{${inset}};
`;

const widthFillAvailable = () => `
    width: 100%;
    width: -webkit-fill-available;
    width: -moz-available;
    width: fill-available;
`;

export { borderRadius, borderShadow, widthFillAvailable };
